// extracted by mini-css-extract-plugin
export var getInTouchColumn = "index-module--getInTouchColumn--92a00";
export var getInTouchContent = "index-module--getInTouchContent--160ff";
export var getInTouchIcon = "index-module--getInTouchIcon--f82c5";
export var getInTouchItem = "index-module--getInTouchItem--7fca6";
export var getInTouchLabel = "index-module--getInTouchLabel--62317";
export var getInTouchList = "index-module--getInTouchList--105e9";
export var getInTouchTel = "index-module--getInTouchTel--2a0eb";
export var listTitle = "index-module--listTitle--096f8";